import { createSvgIcon } from "@mui/material";

export const Icon = createSvgIcon(
  <>
    <path d="M4.89,20.78c-.49,0-.89-.4-.89-.89v-10.07c0-.56.27-1.09.72-1.43l6.75-5c.31-.23.74-.23,1.06,0l6.75,5c.45.34.72.87.72,1.43v10.07c0,.49-.4.89-.89.89h-4.22c-.49,0-.89-.4-.89-.89v-5.14c0-.49-.4-.89-.89-.89h-2.22c-.49,0-.89.4-.89.89v5.14c0,.49-.4.89-.89.89h-4.22Z" />
  </>,
  "Home",
);

export default Icon;
